import {
  Component,
  Input,
  ChangeDetectorRef,
  ViewEncapsulation,
  ComponentRef,
  ViewChild,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { Subject, Observable } from 'rxjs';

import { BaseComponentCanDeactivate } from 'app/@auth/guards/changes.guard';
import {
  FitnessItem,
  SetsBased,
  SettingDetailRow,
  WeightType,
  BlockType,
  FitnessBlock,
  FitnessItemHelper,
} from 'app/@core/interfaces/common/CalorieFriend/fitnessItem';
import { ExerciseProgressData } from 'app/@core/interfaces/common/CalorieFriend/exercise-progress';
/**
 * Base component for individual Meal/Food Item among the items list of one Meal Set presentation components.
 */
@Component({
  selector: 'app-fitness-item-presentation-base',
  template: `<ng-template></ng-template>`,
  styleUrls: [
    './fitness-item-presentation.component.scss',
    '../../global.component.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class FitnessItemPresentationComponentBase
  extends BaseComponentCanDeactivate
  implements OnInit
{
  ItemQuantity = '';
  ItemQuantityTimes = '';
  ShowQuanitity = false;
  CurrentSelection = '';
  FatPercent = '';
  SatFatPercent = '';
  CholesterolPercent = '';
  SodiumPercent = '';
  CarbPercent = '';
  FiberPercent = '';

  AboutLabel = $localize`:@@SmallAbout:about`;

  Math = Math;

  WeightType = WeightType;

  @Input('BlockType') BlockType: BlockType;
  @Input('CircuitRest') CircuitRest: number = 0;

  @Input('FitnessItem') Item: FitnessItem;
  @Input('OverlayMealItem') OverlayItem: FitnessItem = null;
  @Input('UpdateCallBack') UpdateCallBack = null;

  @Input('PatientID') PatientID: number = -1;
  @Input('PatientName') PatientName: string = '';
  @Input('IsPreferredUnitImperial') IsPreferredUnitImperial: boolean = false;

  @Input('IsPatientView') IsPatientView: boolean = false;

  @Input('DeleteCallBack') DeleteCallBack = null;
  @Input('SaveCallBack') SaveCallBack = null;

  @Input('IsViewOnly') IsViewOnly: boolean = false;

  @Input('IsLastItem') IsLastItem: boolean = false;

  @Input('BlockOrder') BlockOrder: number = 1;
  @Input('fitnessBlock') fitnessBlock: FitnessBlock
  

  protected readonly unsubscribe$ = new Subject<void>();

  ItemSelection = '';
  PortionSelectionWithQuantity = '';

  CurrentSelectedServingSizeIndex = 0;

  VisualStyle = '';
  Updating: boolean = false;

  /** MealItemPresentation ctor */
  constructor(
    dialogService: NbDialogService,
    private exerciseProgressService: ExerciseProgressData // protected ref: NbDialogRef<ServingSizeSelectionComponent>
  ) {
    super(dialogService);
  }


  public get IsSuperSet() {
    return FitnessItemHelper.IsSuperSet(this.Item);
  }

  public get GetSupersetMaster(): FitnessItem {
    return FitnessItemHelper.GetSupersetMaster(this.Item, this.fitnessBlock);
  }

  public get IsSupersetMaster() {
    return FitnessItemHelper.IsSupersetMaster(this.Item, this.fitnessBlock);
  }

  public get IsSuperSetWithNext() {
    return FitnessItemHelper.IsSuperSetWithNext(this.Item, this.fitnessBlock);
  }

  public get IsSuperSetSlave() {
    return FitnessItemHelper.IsSuperSetSlave(this.Item, this.fitnessBlock);
  }

  public get IsValidSuperset() {
    return FitnessItemHelper.GetSupersetMaster(this.Item, this.fitnessBlock) != null;
  }



  
  get RestToNext() {
    let restItem = this.Item.restBeforeNextExercise;

    if (this.BlockType.toString() === BlockType.Circuit.toString()) {
      restItem = this.CircuitRest;
    }

    if (restItem > 0) {
      if (restItem < 60) {
        return `${restItem} sec. rest`;
      } else {
        const min = Math.floor(restItem / 60);
        const sec = restItem % 60;
        if (sec > 0) {
          return `${min}m ${sec} s rest`;
        } else {
          return `${min} min rest`;
        }
      }
    } else {
      return 'No rest';
    }
  }

   
  get RestEnd() {
    let restItem = this.fitnessBlock.restEnd;

    if (restItem > 0) {
      if (restItem < 60) {
        return `${restItem} sec. rest`;
      } else {
        const min = Math.floor(restItem / 60);
        const sec = restItem % 60;
        if (sec > 0) {
          return `${min} m ${sec} s rest`;
        } else {
          return `${min} min rest`;
        }
      }
    } else {
      return 'No rest';
    }
  }



  /**
   * Initializes the component.
   * Sets the event handlers and subscribers for serving size changes.
   */
  ngOnInit(): void {
    if (this.OverlayItem != null && this.OverlayItem !== undefined) {
      this.Item = this.OverlayItem;
    }

    // one max rep
    // if (this.Item) {
      // this.exerciseProgressService
      //   .getOneMaxRep(this.PatientID, this.Item.exerciceId)
      //   .subscribe(
      //     (data) => {
      //       if (data) this.Item.oneRepMax = data.oneMaxRep;
      //     },
      //     () => {}
      //   );
    // }
  }

  get OrderLabel(): string {
    if (this.BlockOrder > 0 && this.BlockOrder < 100) {
      return (
        String.fromCharCode(64 + this.BlockOrder) +
        (this.Item.order + 1).toString()
      );
    } else {
      return (this.Item.order + 1).toString();
    }
  }
}
